import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { PrimeReactProvider } from 'primereact/api';

ReactDOM.render(
  <PrimeReactProvider>
    <App />
  </PrimeReactProvider>,
  document.getElementById('root')
);